import { render, staticRenderFns } from "./PrintJournal.vue?vue&type=template&id=b30a621a&"
import script from "./PrintJournal.vue?vue&type=script&lang=ts&"
export * from "./PrintJournal.vue?vue&type=script&lang=ts&"
import style0 from "./PrintJournal.vue?vue&type=style&index=0&id=b30a621a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports